/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{forwardRefWithAs as e,render as r}from"../utils/render.js";var d,i=((d=i||{})[d.None=1]="None",d[d.Focusable=2]="Focusable",d[d.Hidden=4]="Hidden",d);let o=e((function(e,d){let{features:i=1,...o}=e,t={ref:d,"aria-hidden":2==(2&i)||void 0,style:{position:"fixed",top:1,left:1,width:1,height:0,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...4==(4&i)&&2!=(2&i)&&{display:"none"}}};return r({ourProps:t,theirProps:o,slot:{},defaultTag:"div",name:"Hidden"})}));export{i as Features,o as Hidden};
//# sourceMappingURL=hidden.js.map
